// extracted by mini-css-extract-plugin
module.exports = {"root":"W_bJ"};